// The guided tour of Admin → Access, for administrators (who edit page sets),
// HR (who edit team membership) and team leads (who edit their own team's).
// Steps point at [data-tour] anchors on AccessPage. Steps about page sets are
// gated on `canEdit` so HR and team leads are not shown controls they do not
// have.

export const ACCESS_TOUR_ID = 'access';

const switchTo = (label) => {
  const tabs = document.querySelector('[data-tour="tabs"]');
  const btn = [...(tabs?.querySelectorAll('button') || [])].find(b => b.textContent.trim() === label);
  btn?.click();
};

export const accessTourSteps = [
  {
    title: 'Access',
    target: '[data-tour="page-header"]',
    before: () => switchTo('Teams'),
    body: [
      'Who reaches which page in the platform. Access is one table: a team, a role or a person holds a page, and somebody reaches it if any of theirs does. Teams carry the bulk; roles add the narrower extras; a direct grant covers the one person who needs something nobody else in their team does.',
      'Use Next to walk through, or Skip if you would rather explore. The ? by the title replays this.',
    ],
  },
  {
    title: 'Teams, roles and people',
    target: '[data-tour="tabs"]',
    body: [
      'The same table three ways. Teams shows what each team reaches and who is in it. Roles shows the supplementary roles, one column each. People shows one person at a time: everything they reach and the reason for each line.',
    ],
    when: (ctx) => !!ctx?.canEdit,
  },
  {
    title: 'The matrix',
    target: '[data-tour="matrix"]',
    before: () => switchTo('Teams'),
    body: [
      'A tick is access; unticking removes it. Save a column with the Save that appears under its name, or Reset to discard. Lines shown as ↳ are actions within a page, and can only be ticked once the page itself is. The SOW lines under Commercial stand on their own, because every member of staff can open a SOW: one per value band, saying who may approve the issue of a SOW worth that much, one for sending an issued SOW to the client, the ones that say who may create and edit a SOW, add or remove its milestones, close a draft, mark it Complete or delete it, and one for who sees a SOW\'s values, rates, costs and contractor pay: everybody else still opens the SOW, without the money.',
      'Removing a page shows who would lose it before anything is saved, and lets you give it to anyone who still needs it as a direct grant.',
    ],
    when: (ctx) => !!ctx?.canEdit,
  },
  {
    title: 'Who is in a team',
    target: '[data-tour="matrix"]',
    before: () => switchTo('Teams'),
    body: [
      'Click a team name to see its members and its pages. A person\'s primary team is set on their record; members added here are additional and reach this team\'s pages as well as their own team\'s.',
      'Administrators and HR may add and remove members of any team. A team\'s lead may add and remove members of their own.',
    ],
  },
];
